<template>
    <az-container>
        <az-form>
            <v-dialog value="true" persistent max-width="800" non-linear>
                <v-card>
                    <v-card-title class="title primary white--text thin" primary-title>
                        <span v-if="dadosGeraisSolicitacao.situacao != 'RASCUNHO'"
                              class="thin--span">Solicitação de {{ item | tipoAnexoFornecedor }}
                        </span>
                        <span v-else
                            class="thin--span">Editar Rascunho de {{ item | tipoAnexoFornecedor }}
                        </span>
                        <v-btn icon @click.native="fecharModal" dark>
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-flex xs12 sm12 d-flex class="header">
                        <v-layout wrap align-center>
                            <v-flex v-if="dadosGeraisSolicitacao.dataCadastro" xs12 sm3 d-flex>
                              <div class="az-text">
                                <label class="primary--text font-weight-bold">Data/Hora Criação</label>
                                <p>{{ dadosGeraisSolicitacao.dataCadastro | dataHumanizada }}</p>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm2 d-flex>
                              <div class="az-text">
                                <label class="primary--text font-weight-bold">Nº Edital</label>
                                <p>{{ licitacao.numeroEdital }}</p>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm2 d-flex>
                              <div class="az-text">
                                <label class="primary--text font-weight-bold">Situação</label>
                                <p v-if="!dadosGeraisSolicitacao.situacao">{{'Rascunho'}}</p>
                                <p v-if="dadosGeraisSolicitacao.situacao">{{ dadosGeraisSolicitacao.situacao | azEnum(tiposSituacaoEsclarecimentoImpugnacao) }}</p>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm9 d-flex>
                                <div class="az-text">
                                    <label class="primary--text font-weight-bold">Objeto</label>
                                    <p>{{ licitacao.objeto }}</p>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <p class="primary--text subtitle">Assunto {{ item | tipoAnexoFornecedor }}
                        <span class="ml-1 red--text">*</span>
                        <span class="ml-1 red--text"
                              v-if="limiteTextoAtingido">Limite máximo de caracteres atingido!</span>
                    </p>
                    <v-card-text>
                        <v-textarea class="textarea-resposta" placeholder="Informe o assunto..."
                                    v-model="dadosGeraisSolicitacao.assunto" v-on:keyup="contarTamanhoTexto" counter/>
                    </v-card-text>
                    <div v-if="dadosGeraisSolicitacao.arquivoNome && dadosGeraisSolicitacao.arquivoUri">
                        <p class="primary--text subtitle" style="margin-top: -20px">Anexo</p>
                        <v-flex xs12 sm12 d-flex class="header ml-5" style="margin-right: 56px">
                            <v-layout wrap align-center>
                                <span style="font-size: 12px; font-family: 'Roboto', sans-serif;">Nome</span>
                                <v-spacer></v-spacer>
                                <span style="font-size: 12px; font-family: 'Roboto', sans-serif;">Ações</span>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 d-flex class="header mb-1 mt-3">
                            <div style="border-top: 1px solid #ccc;"></div>
                        </v-flex>
                        <v-flex xs12 sm12 d-flex class="header mx-5 mt-0">
                            <v-layout wrap align-center>
                                <span style="color: black; font-size: 13px; font-family: 'Roboto', sans-serif;">
                                    {{ dadosGeraisSolicitacao.arquivoNome }}
                                </span>
                                <v-spacer></v-spacer>
                                <a :href="criarLinkDownload(dadosGeraisSolicitacao.arquivoUri)" target="_blank">
                                    <v-icon>get_app</v-icon>
                                </a>
                                <a @click.prevent="removerAnexo()">
                                    <v-icon>close</v-icon>
                                </a>
                            </v-layout>
                        </v-flex>
                    </div>
                    <div v-else>
                        <p class="primary--text subtitle" style="margin-top: -20px">Anexo</p>
                        <licitacao-esclarecimento-anexo style="margin-top: -20px" @uploadArquivo="setarArquivoUpload" @removerArquivoUpload="removerArquivoUpload" @configuracaoRepositorio="setarRepositorio"/>
                    </div>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <div>
                            <button v-if="dadosGeraisSolicitacao.assunto" class="action-primary-button"
                                    @click.prevent="validarAnexoSalvar" :disabled="enviandoSolicitacao"
                                    >
                                Salvar {{ item | tipoAnexoFornecedor }}
                            </button>
                            <div v-else>
                                <v-tooltip top nudge-top="10" max-width="200">
                                    <template v-slot:activator="{ on }">
                                        <button v-on="on" class="action-primary-button-disabled btn-disabled">
                                            Salvar {{ item | tipoAnexoFornecedor }}
                                        </button>
                                    </template>
                                    É necessário que todos os campos obrigatórios sejam preenchidos para continuar.
                                </v-tooltip>
                            </div>
                        </div>
                        <div>
                            <button v-if="dadosGeraisSolicitacao.assunto" class="action-primary-button"
                                    @click.prevent="validarAnexoEnviar" :disabled="enviandoSolicitacao"
                            >
                              Enviar {{ item | tipoAnexoFornecedor }}
                            </button>
                            <div v-else>
                              <v-tooltip top nudge-top="10" max-width="200">
                                <template v-slot:activator="{ on }">
                                  <button v-on="on" class="action-primary-button-disabled btn-disabled">
                                    Enviar {{ item | tipoAnexoFornecedor }}
                                  </button>
                                </template>
                                É necessário que todos os campos obrigatórios sejam preenchidos para continuar.
                              </v-tooltip>
                            </div>
                        </div>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </az-form>
        <modal-confirmar-etapa-anexo
                v-model="exibirConfirmacaoAnexoSalvar"
                :title="'Solicitação ' + this.tipoAnexoFornecedor(item)"
                textConfirm="Sim, salvar"
                :text="mensagem1AvisoAnexoRascunho"
                :secondText="mensagem2AvisoAnexoRascunho"
                :mensagemRascunho="mensagemRascunho"
                @fecharModalConfirm="fecharModalAnexoRascunho"
                @cancelarAcao="fecharModalAnexoRascunho"
                @confirmarAcao="confirmarSalvarRascunho"
        />
        <modal-confirmar-etapa-anexo
          v-model="exibirConfirmacaoAnexoEnviar"
          :title="'Solicitação ' + this.tipoAnexoFornecedor(item)"
          text="Atenção, nenhum anexo foi"
          secondText="inserido, deseja continuar?"
          @fecharModalConfirm="exibirConfirmacaoAnexoEnviar = false"
          @cancelarAcao="exibirConfirmacaoAnexoEnviar = false"
          @confirmarAcao="enviarSolicitacao(); exibirConfirmacaoAnexoEnviar = false;"
        />
    </az-container>
</template>

<script>
    import _ from 'lodash'
    import {mapActions, mapState} from 'vuex'
    import {actionTypes, tiposAnexoFornecedor, tiposSituacaoEsclarecimentoImpugnacao} from '@/commons/constants'
    import ModalConfirmarEtapaAnexo from '@/commons/components/ModalConfirmarEtapaAnexo'
    import LicitacaoEsclarecimentoAnexo from '../../commons/LicitacaoEsclarecimentoAnexo'
    import CampoApresentacao from '@/commons/components/campos/campo-apresentacao.vue'

    export default {
        name: 'LicitacaoFornecedorEsclarecimentoSolicitacao',
        components: {CampoApresentacao, LicitacaoEsclarecimentoAnexo, ModalConfirmarEtapaAnexo},
        props: {
            item: String,
            solicitacao: Object
        },
        data() {
            return {
                maxTextArea: 1000,
                totalRemainCount: 1000,
                limiteTextoAtingido: false,
                exibirConfirmacaoAnexoSalvar: false,
                exibirConfirmacaoAnexoEnviar: false,
                enviandoSolicitacao: false,
                anexoRemovido: false,
                tiposSituacaoEsclarecimentoImpugnacao,
                mensagem1AvisoAnexoRascunho: null,
                mensagem2AvisoAnexoRascunho: null,
                mensagemRascunho: null,
                dadosGeraisSolicitacao: {
                  licitacao: {id: undefined},
                  assunto: '',
                  usuario: {id: undefined},
                  tipo: '',
                  arquivoUri: null,
                  arquivoNome: null,
                  repositorioUri: null
                },
                repositorio: null
            }
        },
        computed: {
            ...mapState(['licitacao'])
        },
        mounted() {
            this.setarDadosGeraisSolicitacao()
        },
        methods: {
            setarDadosGeraisSolicitacao(){
                if(this.solicitacao){
                  this.dadosGeraisSolicitacao = _.cloneDeep(this.solicitacao)
                }
                this.dadosGeraisSolicitacao.anexoUpload = null
                this.dadosGeraisSolicitacao.anexoRemovido = false
                this.dadosGeraisSolicitacao.repositorioUri = this.repositorio
            },
            validarAnexoSalvar() {
                if (this.dadosGeraisSolicitacao.arquivoUri || this.dadosGeraisSolicitacao.anexoUpload){
                    this.mensagem1AvisoAnexoRascunho = null
                    this.mensagem2AvisoAnexoRascunho = null
                } else {
                    this.mensagem1AvisoAnexoRascunho = 'Atenção, nenhum anexo foi'
                    this.mensagem2AvisoAnexoRascunho = 'inserido, deseja continuar?'
                }
                    this.mensagemRascunho = this.montarMensagemRascunho()
                    this.exibirConfirmacaoAnexoSalvar = true
            },
            montarMensagemRascunho() {
              if(this.item === 'IMPUGNACAO')
                return 'Sua impugnação foi salva como rascunho e '
              return 'Seu esclarecimento foi salvo como rascunho e '
            },
            validarAnexoEnviar() {
                if (this.licitacao.status === 'ENCERRADO') {
                    this.mostrarNotificacaoErro('Não é possível enviar um esclarecimento/impugnação para um processo encerrado.')
                    return
                }
                if (!this.dadosGeraisSolicitacao.arquivoUri && !this.dadosGeraisSolicitacao.anexoUpload)
                    this.exibirConfirmacaoAnexoEnviar = true;
                else
                    this.enviarSolicitacao()
            },
            contarTamanhoTexto() {
                this.totalRemainCount = this.maxTextArea - this.dadosGeraisSolicitacao.assunto.length;

                this.limiteTextoAtingido = this.totalRemainCount < 0;
                if (this.limiteTextoAtingido) this.dadosGeraisSolicitacao.assunto = this.dadosGeraisSolicitacao.assunto.slice(0, this.totalRemainCount)
            },
            async salvarSolicitacao() {
                if (this.dadosGeraisSolicitacao.id) {
                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Editando solicitação...')

                    await this.editarEsclarecimentoImpugnacao(this.dadosGeraisSolicitacao)
                    this.$emit('solicitacaoEditada')

                    this.desabilitarLoadingGlobal()
                    this.mostrarNotificacaoSucessoDefault()
                } else {
                    this.dadosGeraisSolicitacao.usuario.id = this.loki.user.id
                    this.dadosGeraisSolicitacao.tipo = this.item
                    this.dadosGeraisSolicitacao.licitacao.id = this.licitacao.id
                    this.dadosGeraisSolicitacao.situacao = 'RASCUNHO'

                if(this.dadosGeraisSolicitacao.assunto.length > 1000){
                  this.mostrarNotificacaoErro("O assunto não deve ultrapassar o limite de 1000 caracteres!")
                  return
                }

                this.habilitarLoadingGlobal()
                this.setMensagemLoading('Enviando solicitação...')

                    await this.inserirEsclarecimentoImpugnacao({
                        licitacaoId: this.licitacao.id,
                        solicitacao: this.dadosGeraisSolicitacao
                    })
                    this.desabilitarLoadingGlobal()
                    this.mostrarNotificacaoSucessoDefault()
                    this.$emit('solicitacaoSalva')
                    this.resetarSolicitacao()
                }
            },
            async enviarSolicitacao() {
                if (this.dadosGeraisSolicitacao.id) {
                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Enviando solicitação...')

                    await this.editarEsclarecimentoImpugnacao(this.dadosGeraisSolicitacao)
                    await this.enviarEsclarecimentoImpugnacao(this.dadosGeraisSolicitacao.id)
                    this.$emit('solicitacaoEnviada')

                    this.desabilitarLoadingGlobal()
                    this.mostrarNotificacaoSucessoDefault()
                } else {
                    this.dadosGeraisSolicitacao.usuario.id = this.loki.user.id
                    this.dadosGeraisSolicitacao.tipo = this.item
                    this.dadosGeraisSolicitacao.licitacao.id = this.licitacao.id
                    this.dadosGeraisSolicitacao.situacao = 'AGUARDANDO'

                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Enviando solicitação...')

                    await this.inserirEsclarecimentoImpugnacao({
                        licitacaoId: this.licitacao.id,
                        solicitacao: this.dadosGeraisSolicitacao
                    })
                    this.desabilitarLoadingGlobal()
                    this.mostrarNotificacaoSucessoDefault()
                    this.$emit('solicitacaoSalva')
                    this.resetarSolicitacao()
                }
            },
            tipoAnexoFornecedor(tipoAnexoChave) {
                const tipoSelecionado = tiposAnexoFornecedor.find(tipoObj => tipoObj.chave === tipoAnexoChave)
                return tipoSelecionado ? tipoSelecionado.label : ''
            },
            removerAnexo() {
              this.dadosGeraisSolicitacao.arquivoNome = null
              this.dadosGeraisSolicitacao.arquivoUri = null
              this.dadosGeraisSolicitacao.anexoRemovido = true
            },
            resetarSolicitacao() {
                this.dadosGeraisSolicitacao.assunto = ''
                this.dadosGeraisSolicitacao.arquivoNome = null
                this.dadosGeraisSolicitacao.arquivoUri = null
                this.dadosGeraisSolicitacao.anexoRemovido = false
                this.dadosGeraisSolicitacao.anexoUpload = null
            },
            fecharModal() {
                if (this.dadosGeraisSolicitacao.id) {
                    this.$emit('solicitacaoEditada')
                }
                this.resetarSolicitacao()
                this.$emit('fecharDetalhe')
            },
            setarArquivoUpload(arquivoUpload){
                this.dadosGeraisSolicitacao.anexoUpload = arquivoUpload
            },
            removerArquivoUpload(){
                this.dadosGeraisSolicitacao.anexoUpload = null
            },
            setarRepositorio(repositorioUri){
                this.repositorio = repositorioUri
            },
            fecharModalAnexoRascunho() {
                this.exibirConfirmacaoAnexoSalvar = false
                this.mensagemRascunho = null
            },
            confirmarSalvarRascunho() {
                this.salvarSolicitacao()
                this.fecharModalAnexoRascunho()
            },
            ...mapActions([actionTypes.INSERIR_ESCLARECIMENTO_IMPUGNACAO, actionTypes.EDITAR_ESCLARECIMENTO_IMPUGNACAO,
              actionTypes.ENVIAR_ESCLARECIMENTO_IMPUGNACAO])
        },
        filters: {
            tipoAnexoFornecedor(tipoAnexoChave) {
                const tipoSelecionado = tiposAnexoFornecedor.find(tipoObj => tipoObj.chave === tipoAnexoChave)
                return tipoSelecionado ? tipoSelecionado.label : ''
            }
        }
    }
</script>

<style lang="stylus">

    .thin
        height: 55px
        justify-content: space-between;
        align-content: center;

    .header
        margin: 10px 20px;
        color: #777777 !important

    .content
        font-size: 16px;
        margin: 0 10px;
        color: #777777 !important

    .subtitle
        font-size: 16px;
        font-weight: bold;
        margin: 0 20px;
        border-bottom: 0 solid #ccc;

    .fileDownload
        font-size: 13px;
        margin: 10px 20px;
        border-bottom: 1px solid #1145ff;
        color: #1145ff;

</style>